module.exports = "images/default_okoo.2f2f0c36.png";